export const FETCH_TENANT_LIST_REQUEST = "FETCH_TENANT_LIST_REQUEST";
export const FETCH_TENANT_LIST_SUCCESS = "FETCH_TENANT_LIST_SUCCESS";
export const FETCH_TENANT_LIST_FAILURE = "FETCH_TENANT_LIST_FAILURE";
export const FETCH_TENANT_LIST_RESET = "FETCH_TENANT_LIST_RESET";
export const fetchTenantListSuccess = (payload) => ({
    type: FETCH_TENANT_LIST_SUCCESS,
    payload,
});
export const fetchTenantListRequest = (payload) => ({
    type: FETCH_TENANT_LIST_REQUEST,
    payload,
});
export const fetchTenantListFailure = (payload) => ({
    type: FETCH_TENANT_LIST_FAILURE,
    payload,
});
export const fetchTenantListReset = () => ({
    type: FETCH_TENANT_LIST_RESET,
});
